var bs_gutter;
const swipers = {};

document.addEventListener('DOMContentLoaded', (event) => {
    console.info('swiper setup');
    
    bs_gutter = getComputedStyle(document.documentElement).getPropertyValue('--grid-gutter-width');
    bs_gutter = Number(bs_gutter);

    // swiper Section top - generic top section swiper setup
    swipers.swiperSectionTop = new Swiper('.swiper--section-top .swiper.enabled', {
        direction: 'horizontal',
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            clickable: true,
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    
    
    // swiper HP Technology left
    swipers.swiperHpTechLeft = new Swiper('.swiper--hp-technology-left .swiper', {
        direction: 'vertical',
        speed: 500,
        // po fixe update na verziu 9.#.#: https://github.com/nolimits4web/swiper/issues/6381 
        touchReleaseOnEdges: true,
        effect: "coverflow",
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: "1",
            coverflowEffect: {
                rotate: 0,
                stretch: "38%",
                depth: 50,
                modifier: 2,
                slideShadows: true,
                scale: 0.95,
            },
        pagination: {
            clickable: true,
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // CTA change
        on: {
            init: function () {
                changeSwiperCta(this);
            },
            activeIndexChange: function () {
                changeSwiperCta(this);
            },
        },
    });
    
    
    // swiper HP Technology right
    swipers.swiperHpTechRight = new Swiper('.swiper--hp-technology-right .swiper', {
        direction: 'vertical',
        speed: 500,
        // po fixe update na verziu 9.#.#: https://github.com/nolimits4web/swiper/issues/6381 
        touchReleaseOnEdges: true,
        effect: "coverflow",
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: "1",
            coverflowEffect: {
                rotate: 0,
                stretch: "38%",
                depth: 50,
                modifier: 2,
                slideShadows: true,
                scale: 0.95,
            },
        pagination: {
            clickable: true,
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // CTA change
        on: {
            init: function () {
                changeSwiperCta(this);
            },
            activeIndexChange: function () {
                changeSwiperCta(this);
            },
        },
    });

    // Cahnge HP Technology swiper CTA
    function changeSwiperCta(swiper){
        let swiper_container = swiper.el.parentElement,
            slide_cta = swiper_container.querySelector('.swiper-cta'),
            slide_url = swiper.slides[swiper.activeIndex].dataset.itemUrl,
            slide_btn_title = swiper.slides[swiper.activeIndex].dataset.itemBtnTitle;

        slide_cta.href = slide_url || '#';
        slide_cta.text = slide_btn_title;
    };


    // swiper HP Product packages
    swipers.swiperHpProductPackages = new Swiper('.swiper--hp-product-packages .swiper', {
        direction: 'horizontal',
        loop: false,
        speed: 800,
        slidesPerView: 3,
        allowTouchMove: true,
        spaceBetween: bs_gutter,
        breakpoints: {
            // when window width is >= ###px
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });


    // swiper HP Experience
    swipers.swiperExperience = new Swiper('.swiper-experience .swiper', {
        direction: 'horizontal',
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    

    // swiper Testimonials
    swipers.swiperHpTestimonials = new Swiper(".swiper-testimonials .swiper", {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        autoHeight: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            // when window width is >= ###px
            1024: {
                autoHeight: false,
            }
        },
    });


    // swiper HP Clients
    swipers.swiperHpClients = new Swiper(".swiper--hp-clients .swiper", {
        loop: true,
        autoplay: true,
        spaceBetween: 30,
        slidesPerView: 2.35,
        centeredSlides: true,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            // when window width is >= ###px
            320: {
                slidesPerView: 2.35,
            },
            480: {
                slidesPerView: 3.5,
            },
            768: {
                slidesPerView: 4.5,
            },
            1024: {
                slidesPerView: 5,
            }
        }
    });


    // swiper Article gallery
    swipers.swiperArticleGalleryThumbs = new Swiper(".swiper--article-gallery__thumbs .swiper", {
        loop: false,
        spaceBetween: 22,
        slidesPerView: 2.5,
        freeMode: true,
        breakpoints: {
            // when window width is >= ###px
            320: {
                slidesPerView: 3.5,
            },
            480: {
                slidesPerView: 4.5,
            },
            768: {
                slidesPerView: 5.5,
            },
            1024: {
                slidesPerView: 5.5,
            }
        }
    });
    swipers.swiperArticleGallery = new Swiper(".swiper--article-gallery .swiper", {
        loop: false,
        spaceBetween: 30,
        slidesPerView: 1,
        autoHeight: true,
        speed: 500,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swipers.swiperArticleGalleryThumbs,
        },
    });

    
    // swiper Support services
    swipers.swiperSupportServicesLeft = [];
    swipers.swiperSupportServicesRight = [];

    // swiper Support services Left - text
    document.querySelectorAll('.swiper--support-services-t-left .swiper').forEach(function(el,i){
        swipers.swiperSupportServicesLeft[i] = new Swiper(el, {
            //autoHeight: true, //problem kedy wrapper nastavoval nespravnu vysku
            direction: 'horizontal', // opravit CSS
            speed: 500,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            pagination: 0,
            // po fixe update na verziu 9.#.#: https://github.com/nolimits4web/swiper/issues/6381 
            touchReleaseOnEdges: true,
            navigation: {
                nextEl: el.parentElement.querySelector('.swiper-button-next'),
                prevEl: el.parentElement.querySelector('.swiper-button-prev')
            },
            breakpoints: {
                // when window width is >= ###px
                768: {
                    //direction: 'horizontal',
                },
            }
            
        });
    });
    
    // swiper Support services Right - image
    document.querySelectorAll('.swiper--support-services-right .swiper').forEach(function(el,i){
        swipers.swiperSupportServicesRight[i] = new Swiper(el, {
            direction: 'vertical',
            //loop: true,
            speed: 500,
            // po fixe update na verziu 9.#.#: https://github.com/nolimits4web/swiper/issues/6381 
            touchReleaseOnEdges: true,
            effect: "coverflow",
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: "1",
                coverflowEffect: {
                    rotate: 0,
                    stretch: "38%",
                    depth: 50,
                    modifier: 2,
                    slideShadows: true,
                    scale: 0.95,
                },
            pagination: {
                clickable: true,
                el: '.swiper-pagination',
            },
            navigation: 0
        });
    });

    // synch sliders
    swipers.swiperSupportServicesLeft.forEach(function(el,i){
        swipers.swiperSupportServicesLeft[i].controller.control = swipers.swiperSupportServicesRight[i];
        swipers.swiperSupportServicesRight[i].controller.control = swipers.swiperSupportServicesLeft[i];
    });


    // swiper About timeline Left - text
    swipers.swiperAboutTimelineLeft = new Swiper('.swiper--about-timeline-t-left .swiper', {
        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 1,
        speed: 500,
        // po fixe update na verziu 9.#.#: https://github.com/nolimits4web/swiper/issues/6381 
        touchReleaseOnEdges: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },    
        pagination: {
            clickable: true,
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper--about-timeline-t-left .swiper-button-next',
            prevEl: '.swiper--about-timeline-t-left .swiper-button-prev',
        },        
        breakpoints: {
            // when window width is >= ###px
            768: {
                autoHeight: 0,
            },
        }
        
    });
    
    // swiper About timeline Right - timeline
    swipers.swiperAboutTimelineRight = new Swiper('.swiper--about-timeline-right .swiper', {
        direction: 'vertical',
        spaceBetween: 0,
        speed: 500,
        slidesPerView: 1,
        grabCursor: 1,
        freeMode: true,
        navigation: 0,
        centeredSlides: 0,
        //autoHeight: true,
        // po fixe update na verziu 9.#.#: https://github.com/nolimits4web/swiper/issues/6381 
        touchReleaseOnEdges: true,
        controller: {
            control: swipers.swiperAboutTimelineLeft
        },
    });

    swipers.swiperAboutTimelineLeft.controller.control = swipers.swiperAboutTimelineRight;


    // swiper Diagrams
    swipers.swiperDiagram = [];
    swipers.swiperDiagramText = [];

    // swiper Diagram - image
    document.querySelectorAll('.swiper--diagram .swiper').forEach(function(el,i){
        swipers.swiperDiagram[i] = new Swiper(el, {
            autoHeight: true,
            direction: 'horizontal', // opravit CSS
            speed: 500,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },  
            pagination: 0,
            // po fixe update na verziu 9.#.#: https://github.com/nolimits4web/swiper/issues/6381 
            navigation: 0,
            zoom: {
                maxRatio: 2,
            },
            pagination: {
                el: ".swiper-pagination, .swiper-pagination--diagram",
                clickable: true,
                renderBullet: function (index, className) {
                    return `
                            <span class="${className} pagination-item-wrapper">
                                <span class="pagination-button shadow" style="${this.slides[index].dataset.mapButton}">${index + 1}</span>
                                <span class="pagination-area" style="${this.slides[index].dataset.mapArea}">${index + 1}</span>
                            </span>
                        `;
                },
            }
        });
    });
    
    // swiper Diagram - text
    document.querySelectorAll('.swiper--diagram-descriptions .swiper').forEach(function(el,i){
        swipers.swiperDiagramText[i] = new Swiper(el, {
            //autoHeight: true,
            speed: 500,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },  
            autoHeight: 1,
            pagination: 0,
            navigation: 0,
            pagination: 0,
            breakpoints: {
                // when window width is >= ###px
                768: {
                    autoHeight: 0,
                },
            }
        });
    });

    // synch sliders
    swipers.swiperDiagram.forEach(function(el,i){
        swipers.swiperDiagram[i].controller.control = swipers.swiperDiagramText[i];
        swipers.swiperDiagramText[i].controller.control = swipers.swiperDiagram[i];
    });
    

// End DOMContentLoaded
});